// extracted by mini-css-extract-plugin
export default {"input":"Input_input__YrP1-","placeholder":"Input_placeholder__gnFQf","search":"Input_search__JUYS1","mb":"Input_mb__sPryN","mb15":"Input_mb15__4gncs","edit":"Input_edit__8dQ1g"};